import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../api'

const initialState = {
    exports: []
}

const exportsSlice = createSlice({
    name: 'exports',
    initialState,
    reducers: {
        updateExportEvents(state, action) {
            console.log("exports state: ", state);
            console.log("export event payload", action.payload);
            console.log("current exports in state:", state.exports);
            console.log("exports array length:", state.exports.length);
            console.log("receiptId from event:", action.payload.event.receiptId);

            // Check if the receiptId from the event matches any export in the state
            // If it does, open the signed URL in a new window
            const matchingExport = state.exports.find(exp => {
                console.log(`Comparing ${exp.receiptId} with ${action.payload.event.receiptId}`);
                return exp.receiptId === action.payload.event.receiptId;
            });

            if (matchingExport) {
                console.log("Found matching export! Opening URL:", matchingExport.signedUrl);
                const a = document.createElement('a');
                a.href = matchingExport.signedUrl;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                // Remove the export from the state after opening
                state.exports = state.exports.filter(e => e.receiptId !== action.payload.event.receiptId);
            } else {
                console.log("No matching export found for receiptId:", action.payload.event.receiptId);
                console.log("Available exports:", state.exports.map(e => e.receiptId));
            }
        },
    },
    // eslint-disable-next-line
    extraReducers: (builder) => {
        builder.addMatcher(
            graphqlApi.endpoints.exportGrid.matchFulfilled,
            (state, { payload }) => {
                console.log("exportGrid payload", payload);
                console.log("receiptId:", payload?.receiptId);
                console.log("signedUrl:", payload?.signedUrl);
                
                // Store the receiptId and signedUrl when export is initiated
                // Data comes directly in payload, not nested under payload.data
                const existingExport = state.exports.find(exp => exp.receiptId === payload?.receiptId);
                if (!existingExport && payload?.receiptId && payload?.signedUrl) {
                    console.log("Adding export to state:", { receiptId: payload.receiptId, signedUrl: payload.signedUrl });
                    state.exports.push({
                        receiptId: payload.receiptId,
                        signedUrl: payload.signedUrl
                    });
                } else {
                    console.log("Not adding export - already exists or missing data");
                }
            }
        )
    }
});
export const { updateExportEvents } = exportsSlice.actions;

export const selectExportsData = (state) => state.exportsSlice

export default exportsSlice.reducer;